import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import ExpandableKpiSummaryComponent from "./ExpandableKpiSummaryComponent";
import MiniLoader from "../../../utilityComponents/MiniLoader";
import ReactPaginate from "react-paginate";
import { Alert } from "react-bootstrap";
import { fetchScenarioDetailsForFilterPage } from "./../../../actions/KpiSummaryDashboardEnhanced/KpiSummaryScenarioTablesAction";
import PropTypes from "prop-types";

const customStyles = {
    rows: {
        style: {
            flexWrap: "nowrap",
            minHeight: "70px",
        },
    },
    headCells: {
        style: {
            fontWeight: "bold",
            fontSize: "70px",
            display: "flex",
            backgroundColor: "white",
            padding: ".75rem",
            verticalAlign: "top",
            borderTop: "1px solid #e9ecef",
            borderBottom: "5px solid #753DFF",
            justifyContent: "center",
        },
    },
    cells: {
        style: {
            width: "200%",
            maxWidth: "70%",
            // backgroundColor: "#C7C9FF",
            fontSize: "0.98rem",
            textAlign: "center",
            verticalAlign: "top",
            borderTop: "5px solid white",
            justifyContent: "center",
            borderBottom: "0",
        },
    },
};

const columns = [
    {
        name: "Base Scenario",
        selector: "baseScenario",
        sortable: true,
        cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.base_scenario}</div>,
    },
    {
        name: "Scenario Variation",
        selector: "scenarioVariation",
        sortable: true,
        cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.scenario_variation}</div>,
    },
    {
        name: "KPI Status",
        selector: "kpiStatus",
        sortable: true,
        cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.kpi_status}</div>,
    },
];

function KpiSummaryScenarioTables(props) {
    const [currentPage, setCurrentPage] = useState(0);
    // const [scenariosPerPage, setScenariosPerPage] = useState(10);
    const [payload, setPayload] = useState("");

    const scenariosPerPage = 10;
    // const [payload, setPayload] = useState("14f2b270-cabe-4410-b199-8728cf4f3953");
    // const [payload, setPayload] = useState("03bceed3-83c3-4604-a4ae-12c2a5d581ae");

    useEffect(() => {
        if (props.cadId.topologyUuid !== undefined) {
            const payload = props.cadId.topologyUuid;
            setPayload(payload);
            props.getScenarioDetailsForFilterPage(payload, currentPage, scenariosPerPage);
        }
    }, []);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        let currentPage = event.selected;
        props.getScenarioDetailsForFilterPage(payload, currentPage, scenariosPerPage);
    };

    return (
        <div>
            <div>
                {props.loading ? (
                    <MiniLoader />
                ) : props.error ? (
                    <Alert key="danger" variant="danger">
                        {props.error}
                    </Alert>
                ) : (
                    // ) : this.props.successSummaryScenarioTablesData.total_variations === 0 ? (
                    //         <Alert key="info" variant="info">
                    //             No records found for this cad topology !
                    //         </Alert>
                    <DataTable
                        className="dataTables_wrapper"
                        columns={columns}
                        customStyles={customStyles}
                        data={props.successSummaryScenarioTablesData}
                        expandableRows
                        expandableRowsComponent={
                            <ExpandableKpiSummaryComponent
                                scenarioUuid={props.successSummaryScenarioTablesData}
                            />
                        }
                        expandOnRowClicked
                        // fixedHeader
                        highlightOnHover
                        pointerOnHover
                        striped
                        // pagination
                        defaultSortField="id"
                        defaultSortAsc={false}
                        setFilter
                    ></DataTable>
                )}
                <ReactPaginate
                    previousLabel="<<"
                    breakLabel="..."
                    nextLabel=">>"
                    onPageChange={handlePageClick}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(
                        props.successSummaryScenarioTablesDataCount / scenariosPerPage
                    )}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    cadId: state.topologyData.topologyData,
    loading: state.KpiSummaryScenarioTablesData.loading,
    successSummaryScenarioTablesData:
        state.KpiSummaryScenarioTablesData.successSummaryScenarioTablesData,
    successSummaryScenarioTablesDataCount:
        state.KpiSummaryScenarioTablesData.successSummaryScenarioTablesDataCount,
    error: state.KpiSummaryScenarioTablesData.error,
    filteredOptions: state.KpiSummaryScenarioFilterData,
});

const mapDispatchToProps = (dispatch) => ({
    getScenarioDetailsForFilterPage: (payload, currentPage, scenariosPerPage) =>
        dispatch(fetchScenarioDetailsForFilterPage(payload, currentPage, scenariosPerPage)),
});

KpiSummaryScenarioTables.propTypes = {
    cadId: PropTypes.object,
    getScenarioDetailsForFilterPage: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.string,
    successSummaryScenarioTablesData: PropTypes.object,
    successSummaryScenarioTablesDataCount: PropTypes.number,
};
KpiSummaryScenarioTables.defaultProps = {
    cadId: {},
    loading: false,
    error: "",
    successSummaryScenarioTablesData: {},
    successSummaryScenarioTablesDataCount: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(KpiSummaryScenarioTables);
